// extracted by mini-css-extract-plugin
export var inputGroupSm = "styles-module--input-group-sm--YJvQj";
export var inputGroupLg = "styles-module--input-group-lg--tEH5B";
export var secondLevelMenuItemTitle = "styles-module--second-level-menu-item-title--3wHms";
export var secondLevelDropdown = "styles-module--second-level-dropdown--3iMrf";
export var secondLevelMenuItemChildren = "styles-module--second-level-menu-item-children--2zQzd";